// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackBtn-module__backBtn___171ij"};